import axios from 'axios';

const API = axios.create({
    // baseURL: 'https://api.zamzam.jp/api',
    baseURL: process.env.REACT_APP_API_URL + '/api',
    withCredentials: true,
});

// Add token to requests
API.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default API;